import { render, staticRenderFns } from "./IntegrationSettings.vue?vue&type=template&id=259c89dc&"
import script from "./IntegrationSettings.vue?vue&type=script&lang=js&"
export * from "./IntegrationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports